import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid
} from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { Trip } from '@/types';

interface TripInfoCardProps {
  trip: Trip;
}

const TripInfoCard: React.FC<TripInfoCardProps> = ({ trip }) => {
  return (
    <Card>
      <CardContent sx={{ p: 3 }}>
        <Typography variant="h4" sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
          🎿 {trip.name}
        </Typography>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <LocationOnIcon style={{ width: 16, height: 16, color: '#6b7280' }} />
              <Typography variant="body2" color="text.secondary">{trip.destination}</Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <CalendarTodayIcon style={{ width: 16, height: 16, color: '#6b7280' }} />
              <Typography variant="body2" color="text.secondary">
                {new Date(trip.startDate).toLocaleDateString()} - {new Date(trip.endDate).toLocaleDateString()}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default TripInfoCard;
